import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { SubmitNewListData } from 'src/app/modules/campaign-management/campaigns/actions/create-new-list.actions';
import { ActiveComponentChanged } from 'src/app/shared/actions/eliqua.actions';
import {
  ButtonPointerEventDisabled,
  ButtonPointerEventEnabled,
  ChangeIgnoreCustomLiterals,
  ChangeIsForImport,
  ChangeSelectOnlyNewStatus,
  ClearImportNewLiterals,
  DropZoneDisabled,
  DropZoneEnabled,
  ExportFileName,
  FileNameChanged,
  FileToUploadChanged,
  GetFile,
  ImportNewLiteralsSuccess,
  RemoveFile,
  UploadedFileChanged,
  ValidateLiteralsSuccess,
} from '../actions/import-export-literals.actions';
import { ImportNewFileRow } from '../models/literals.model';

export interface ImportExportLiteralsState extends ImportNewFileRow {
  ignoreCustom: boolean;
  isForImport: boolean;
  buttonEventsDisabled: boolean;
  enteredDropZone: boolean;
  uploadedFile: { name: string; size: number };
  file: any;
  fileName: string;
  fileToUpload: any;
  exportFileName: string;
  displayedColumns: { [label: string]: string };
  newLiterals: any;
  showUpdateBtn: boolean;
  disabledUpdateBtn: boolean;
  selectOnlyNewStatus: boolean;
}

const initialState: ImportExportLiteralsState = {
  ignoreCustom: false,
  isForImport: false,
  buttonEventsDisabled: false,
  enteredDropZone: false,
  uploadedFile: { name: '', size: 0 },
  file: '',
  fileName: '',
  fileToUpload: '',
  exportFileName: '',
  displayedColumns: {},
  newLiterals: [],
  showUpdateBtn: false,
  lastChangeDate: new Date(),
  language: '',
  literalCode: '',
  currentLiteral: '',
  futureLiteral: '',
  disabledUpdateBtn: false,
  selectOnlyNewStatus: false,
};

export const ImportExportLiteralsReducer = createReducer(
  initialState,
  on(ChangeIgnoreCustomLiterals, (state, { ignoreCustom }) => ({
    ...state,
    ignoreCustom,
  })),
  on(ChangeIsForImport, (state, { isForImport }) => ({
    ...state,
    isForImport,
  })),
  on(DropZoneEnabled, (state) => ({
    ...state,
    enteredDropZone: true,
  })),
  on(DropZoneDisabled, (state) => ({
    ...state,
    enteredDropZone: false,
  })),
  on(ButtonPointerEventEnabled, (state) => ({
    ...state,
    buttonEventsDisabled: false,
  })),
  on(ButtonPointerEventDisabled, (state) => ({
    ...state,
    buttonEventsDisabled: true,
  })),
  on(GetFile, (state, { file }) => ({
    ...state,
    file,
  })),
  on(RemoveFile, (state) => ({
    ...state,
    file: '',
    uploadedFile: { name: '', size: 0 },
  })),
  on(FileNameChanged, (state, { fileName }) => ({
    ...state,
    fileName,
  })),
  on(UploadedFileChanged, (state, { name, size }) => ({
    ...state,
    uploadedFile: { name: name, size: size },
  })),
  on(FileToUploadChanged, (state, { fileToUpload }) => ({
    ...state,
    fileToUpload,
  })),
  on(ActiveComponentChanged, (state) => ({
    ...state,
    buttonEventsDisabled: false,
    enteredDropZone: false,
    uploadedFile: { name: '', size: 0 },
    file: '',
    fileName: '',
    fileToUpload: '',
    exportFileName: '',
    displayedColumns: {},
    newLiterals: [],
    showUpdateBtn: false,
  })),
  on(SubmitNewListData, (state) => ({
    ...state,
    isSubmittedData: true,
  })),
  on(ExportFileName, (state, { exportFileName }) => ({
    ...state,
    exportFileName,
  })),
  on(ValidateLiteralsSuccess, (state, { res }) => ({
    ...state,
    newLiterals: res,
    showUpdateBtn: res ? true : false,
    disabledUpdateBtn: res.length > 0 ? false : true,
  })),
  on(ClearImportNewLiterals, (state) => ({
    ...state,
    showUpdateBtn: false,
    file: '',
    uploadedFile: { name: '', size: 0 },
    fileName: '',
    displayedColumns: {},
    lastChangeDate: new Date(),
    newLiterals: [],
    disabledUpdateBtn: false,
  })),
  on(ImportNewLiteralsSuccess, (state) => ({
    ...state,
    showUpdateBtn: false,
    file: '',
    uploadedFile: { name: '', size: 0 },
    fileName: '',
    displayedColumns: {},
    lastChangeDate: new Date(),
    newLiterals: [],
    disabledUpdateBtn: false,
  })),
  on(ChangeSelectOnlyNewStatus, (state, { selectOnlyNewStatus }) => ({
    ...state,
    selectOnlyNewStatus,
  })),
  on(ActiveComponentChanged, () => initialState),
);
